export const GET_ALL_PART_DEPARTMENTS_REQUEST = 'GET_ALL_PART_DEPARTMENTS_REQUEST';
export const GET_ALL_PART_DEPARTMENTS_SUCCESS = 'GET_ALL_PART_DEPARTMENTS_SUCCESS';
export const DELETE_PART_DEPARTMENT_REQUEST = 'DELETE_PART_DEPARTMENT_REQUEST';
export const DELETE_PART_DEPARTMENT_SUCCESS = 'DELETE_PART_DEPARTMENT_SUCCESS';
export const UPDATE_PART_DEPARTMENT_REQUEST = 'UPDATE_PART_DEPARTMENT_REQUEST';
export const UPDATE_PART_DEPARTMENT_SUCCESS = 'UPDATE_PART_DEPARTMENT_SUCCESS';
export const NEW_PART_DEPARTMENT_REQUEST = 'NEW_PART_DEPARTMETN_REQUEST';
export const NEW_PART_DEPARTMENT_SUCCESS = 'NEW_PART_DEPARTMENT_SUCCESS';
